import ThcProductCard from './product-thc'
import CbdOrHempProductCard from './product-cbd-hemp'

export default
	name: 'ProductCarouselProduct'
	functional: true

	props:
		product: Object

	render: (create, { props, data, children, scopedSlots }) ->
		{ product } = props

		type = product.__typename or product.type

		switch type

			when 'products_thc_Entry', 'thc'
				create ThcProductCard, {
					...data
					props: {
						product: product
					}
				}

			when 'products_cbd_Entry', 'products_hemp_Entry', 'cbd'
				create CbdOrHempProductCard, {
					...data
					props: {
						product: product
					}
				}
